<template>
    <div>
        <el-alert
            v-if="disabled"
            class="warning-message"
            title="Tous les champs et sélecteur de fichier sont requis"
            type="info"
            :closable="false"
            center
        >
        </el-alert>
        <el-upload
            v-if="!isXlsx || xlsxHandled"
            drag
            ref="upload"
            class="upload-demo"
            accept=".csv,.xlsx"
            action=""
            :before-upload="handleChange"
            required
        >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                Glisser un fichier ici ou cliquer pour charger
            </div>
            <div
                slot="tip"
                class="el-upload__tip"
            >
                Type de fichier supporté : csv
            </div>
        </el-upload>
        <xlsx-handler
            v-if="isXlsx && xlsxSheets.length && !xlsxHandled"
            v-show="!plotting_in_progress"
            :sheets="xlsxSheets"
            @config-confirmed="onXlsxConfigConfirmed"
        />
        <div
            ref="graph"
            id="graph"
        ></div>
        <div v-if="plotting_in_progress">
            <p class="waiting">
                Veuillez attendre que les données soient chargées
                <span class="loading-spinner">
                    <i class="el-icon-loading"></i>
                </span>
            </p>
        </div>
        <div
            v-if="uploadedFile && !plotting_in_progress && (!isXlsx || xlsxHandled)"
            class="rangeSelector"
        >
            <span>
                Date de début - Date de fin
            </span>
            <el-date-picker
                v-model="range"
                @change="changeGraphRange"
                :picker-options="pickerOptions"
                format="dd/MM/yyyy HH:mm"
                type="datetimerange"
                start-placeholder="Date de départ"
                end-placeholder="Date de fin"
                range-separator="À"
                class="datetime"
            >
            </el-date-picker>
        </div>
        <div class="dialogButtons">
            <el-button
                class="whiteButton"
                :disabled="loadings.save"
                @click="closeModal"
            >
                Annuler
            </el-button>
            <el-tooltip
                popper-class="simulationCreationTooltip"
                :visible-arrow="false"
                :disabled="!disabled"
                :content="getContentForTooltip"
                placement="top"
                effect="dark"
            >
                <div>
                    <el-button
                        v-loading="loadings.save"
                        @click="saveRange"
                        :disabled="disabled || loadings.save"
                    >
                        Enregistrer
                    </el-button>
                </div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
import moment from 'moment-timezone';
import Plotly from 'plotly.js-basic-dist';
import { read, utils } from 'xlsx';
import XlsxHandler from './XlsxHandler.vue';
const MEASURE_FILE_VIVECO_MANUEL_FORMAT = 'viveco-manuel';

export default {

    name: 'SimulationModal',

    components: {
        XlsxHandler
    },

    props:{
        item: {
            type: Object,
            required: true
        },
        model:{
            type: String,
            required: true
        }
    },

    data () {
        return {
            loadings: {
                save: false,
                restore: false
            },
            simulationFileFormat: 'unknow',
            plotting_in_progress: false,
            uploadedFile: null,
            isXlsx: false,
            xlsxSheets: [],
            xlsxConfig: null,
            range: [],
            defaultRange: [],
            currentMeasureRequest: null,
            xlsxHandled: false,
             pickerOptions: {
                // disabledDate: (time) => {
                //     if (!this.defaultRange.length) return false; // aucune restriction si pas de bornes
                //     const start = new Date(this.defaultRange[0]);
                //     const end = new Date(this.defaultRange[1]);
                //     return time.getTime() < start.getTime() || time.getTime() > end.getTime();
                // }
            }
        };
    },

    computed:{
        getContentForTooltip() {
            if (this.uploadedFile === null) {
                return 'Sélectionnez un fichier de données pour la simulation';
            }
            if (this.caliberIsMissing) {
                return 'Sélectionnez un calibre pour la simulation';
            }
            if (this.currentMeasureRequest === null) {
                return 'Patientez pendant le chargement des données de simulation';
            }
        },
        disabled() {
            return (!this.uploadedFile || this.caliberIsMissing || !this.currentMeasureRequest || this.plotting_in_progress || (this.isXlsx && !this.xlsxHandled));
        },
        caliberIsNeeded(){
            return this.simulationFileFormat === MEASURE_FILE_VIVECO_MANUEL_FORMAT;
        },
        itemProperties(){
            let properties = {}
            this.$store.state.equipmentProperties.forEach(property => {
                if(this.item && this.item[property.name] !== undefined){
                    properties[property.name] = this.item[property.name];
                }else{
                    return;
                }
            });
            return properties;
        }
    },

    methods:{
        readXlsx(file) {
            this.plotting_in_progress = true;
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = read(data);
                const sheets = workbook.SheetNames.map(name => {
                    const worksheet = workbook.Sheets[name];
                    // Keep blank rows so the preview in XlsxHandler can show them
                    const rows = utils.sheet_to_json(worksheet, {
                        header: 1,
                        raw: false,
                        blankrows: true,
                        defval: ''
                    });
                    return {
                        name,
                        rows
                    };
                });
                this.$set(this, 'xlsxSheets', sheets);
                this.plotting_in_progress = false;
            };
            reader.readAsArrayBuffer(file);
        },
        async uploadFile(){
            this.plotting_in_progress = true;
            this.loadings.save = true;
            let formData = new FormData();
            formData.append('measure_file', this.uploadedFile);
            formData.append('status', 'PENDING');
            let simulationPostData = {
                equipment_properties: this.itemProperties,
                status: 'DRAFT'
            }
            if (this.isXlsx && this.xlsxConfig) {
                simulationPostData.is_xlsx = true;
                simulationPostData.xlsx_data = this.xlsxConfig;
            }

            this.$store.dispatch('createItem', {
                item: simulationPostData,
                url: this.$store.state.api.meta.listModels.simulationMeasureImportRequests.url,
                model: 'simulationMeasureImportRequests',
            }).then((response) => {
                this.$store.dispatch('patchItemFormData', {
                    item: formData,
                    url: response.url,
                    model: 'simulationMeasureImportRequests',
                }).then((res) => {
                    return this.watchModelStatus(res, 'COMPLETED', 'FAILED')
                    .then((updatedRes)=>{
                    
                        this.$notify({
                            type: 'success',
                            title: 'Succès'
                        });
                        const localStartDate = moment(updatedRes.start_date)
                        .tz("Europe/Paris")
                        .format("YYYY-MM-DD HH:mm"); // chaîne locale
                        const localEndDate = moment(updatedRes.end_date)
                        .tz("Europe/Paris")
                        .format("YYYY-MM-DD HH:mm");

                        this.$set(this, 'range', [localStartDate, localEndDate]);
                        this.$set(this, 'simulationFileFormat', updatedRes.format_name);
                        this.formatData(updatedRes.raw_measures);
                        this.$set(this, 'currentMeasureRequest', updatedRes);
                        if(this.isXlsx){
                            this.$set(this, 'xlsxHandled', true);
                        }
                        this.loadings.save = false;
                        this.plotting_in_progress = false;
                    }).catch((error2) => {
                        this.loadings.save = false;
                        this.plotting_in_progress = false;
                        this.$notify({
                            type: 'error',
                            title: 'Erreur',
                            message: error2.verbose_status
                        });
                    });
                }).catch((error1) => {
                    this.plotting_in_progress = false;
                    this.loadings.save = false;
                    console.log('error1',error1);
                    this.$notify({
                        type: 'error',
                        title: 'Erreur',
                        message: error1.verbose_status
                    });
                });
            });
        },
        async watchModelStatus(itemToWatch, successStatus, failedStatus = null){
            return new Promise((resolve, reject) => {
                let item = itemToWatch;
                let interval = setInterval(async ()=>{
                    if(item.status === successStatus){
                        resolve(item);
                        clearInterval(interval);
                    }
                    if(failedStatus !== null && item.status === failedStatus){
                        reject(item);
                        clearInterval(interval);
                    }
                    this.$store.dispatch('remoteGet', { url : itemToWatch.url })
                    .then(response =>{
                        item = response.data;
                    });
                }, 3000);
            });
        },
        closeModal(){
            this.$set(this, 'simulationFileFormat', 'unknow');
            this.$set(this, 'plotting_in_progress', false);
            this.$set(this, 'uploadedFile', null);
            this.$set(this, 'isXlsx', false);
            this.$set(this, 'xlsxSheets', []);
            this.$set(this, 'xlsxConfig', null);
            this.$set(this, 'range', []);
            this.$set(this, 'defaultRange', []);
            this.$set(this, 'xlsxHandled', false);
            this.$emit('close-simulation-modal');
        },
        changeGraphRange(rangeArray) {
            if (rangeArray) {
                this.$set(this, 'range', rangeArray);
                Plotly.relayout('graph', 'xaxis.range',[moment(rangeArray[0]).format('YYYY-MM-DDTHH:mm:ssZ'), moment(rangeArray[1]).format('YYYY-MM-DDTHH:mm:ssZ')]);
            }
            else {
                Plotly.relayout('graph', 'xaxis.autorange', true);

            }
        },
        handleChange(file) {
            const extension = file.name.split('.').pop().toLowerCase();
            if (extension === 'csv') {
                this.$set(this, 'uploadedFile', file);
                this.$set(this, 'isXlsx', false);
                this.uploadFile();
            } else if (extension === 'xlsx') {
                this.$set(this, 'uploadedFile', file);
                this.$set(this, 'isXlsx', true);
                this.readXlsx(file);
            } else {
                this.$notify({
                    type: 'error',
                    title: 'Erreur',
                    message: 'Type de fichier non supporté. Veuillez sélectionner un fichier .csv ou .xlsx'
                });
                return false;
            }
            // Prevent file uploading
            return false;
        },
        onXlsxConfigConfirmed(config) {
            this.$set(this, 'xlsxConfig', config);
            this.uploadFile();
        },
        async makePlotly(x, y) {
            let traces = [{
                x: x,
                y: y
            }];
            // Use annotations because yaxis.title cannot be rotated
            let layout = {
                annotations: [{
                    xref: 'paper',
                    yref: 'paper',
                    x: 0,
                    xanchor: 'right',
                    y: 1,
                    yanchor: 'bottom',
                    text: '(kW)',
                    showarrow: false
                }],
            };
            if (this.caliberIsNeeded) {
                layout.annotations[0].text = "(mV)";
            }
            await Plotly.newPlot('graph', traces, layout).then(data => {

                const localStartDate = moment(data.layout.xaxis.range[0], "YYYY-MM-DD HH:mm")

                const localEndDate = moment(data.layout.xaxis.range[1], "YYYY-MM-DD HH:mm")
                this.$set(this, 'defaultRange', [
                    localStartDate,
                    localEndDate
                ]);

                // this.$set(this, 'defaultRange', [data.layout.xaxis.range[0], data.layout.xaxis.range[1]]);
                this.$set(this, 'range', this.defaultRange);
            });
            this.plotting_in_progress = false;
            this.$refs.graph.on('plotly_relayout', (data) => {
                if (data['xaxis.range[0]'] && data['xaxis.range[1]']) { // when changes are thrown through the chart
                    this.$set(this, 'range', [data['xaxis.range[0]'], data['xaxis.range[1]']]);
                }
                else if (data['xaxis.range'] && data['xaxis.range'].length === 2) { // when changes are thrown through the datetime picker
                    this.$set(this, 'range', [data['xaxis.range'][0], data['xaxis.range'][1]]);
                }
                else { // when resetting to zoomed out value, or error
                    this.$set(this, 'range', this.defaultRange);
                }
            });
        },
        async formatData(data){
            let x = [];
            let y = [];
            for (let measure of data) {
                x.push(
                    moment(measure.date)
                    .tz("Europe/Paris")
                    .format("YYYY-MM-DDTHH:mm")
                );
                y.push(measure.value);
            }
            await this.makePlotly(x, y);
        },
        saveRange(){
            // Save the current range of the plot
            this.loadings.save = true;
            
            const utcStart = moment(this.range[0])
            .tz("Europe/Paris")
            .utc()
            .format();
            
            const utcEnd = moment(this.range[1])
            .tz("Europe/Paris")
            .utc()
            .format();

            this.$store.dispatch('patchItem', {
                item: {
                    requested_start_date: utcStart,
                    requested_end_date: utcEnd,
                    uid: this.currentMeasureRequest.uid,
                    url: this.currentMeasureRequest.url
                },
                model: 'simulationMeasureImportRequests',
            }).then(() => {
                this.$store.dispatch('patchItem', {
                    item: {
                        simulation_measure_uid: this.currentMeasureRequest.uid,
                        uid: this.item.uid,
                        url: this.item.url,
                    },
                    model: this.model,
                }).then(() => {
                    this.$store.dispatch('resetSimulationData', {
                        item: this.item,
                        itemType: this.model,
                        declarationUpdated: false
                    });
                    this.loadings.save = false;
                    this.plotting_in_progress = false;
                }).catch((error3)=>{
                    this.loadings.save = false;
                    this.plotting_in_progress = false;
                    this.$notify({
                        type: 'error',
                        title: 'Erreur',
                        message: error3.data.verbose_status
                    });
                });
                this.$emit('refresh-data');
                this.closeModal();
            }).catch((error)=>{
                console.error('error',error);
                this.loadings.save = false;
                this.$notify({
                    type: 'error',
                    title: 'Erreur',
                    message: error.data.verbose_status
                });
            });
        }
    }
};
</script>

<style lang="scss">

.simulationCreationTooltip {
    font-size: 13px;
}
.wrapper {
    display: flex;
    width: 100%;
    flex-wrap: nowrap;
    height: auto;
    .button-wrapper {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .title {
            width : 100%;
            margin-bottom: 40px;
        }
    }
    .no-mode-translate-fade-enter-active, .no-mode-translate-fade-leave-active {
        transition: all 0.5s;
    }
    .no-mode-translate-fade-enter, .no-mode-translate-fade-leave-active {
        opacity: 0;
    }
    .no-mode-translate-fade-enter {
        transform: translateX(31px);
    }
    .no-mode-translate-fade-leave-active {
        transform: translateX(-31px);
    }
    .factories, .motors {
        margin: 0 auto 30px;
    }
}

.upload-demo .el-upload input[type="file"]{
    display: none;
}

.researchField {
    margin-top: 20px;
    input {
        border-top: none;
        border-left: none;
        border-right: none;
        border-radius: 0;
        transition-duration: 0.4s;
        &:focus {
            border-bottom-width: 2px !important;
        }
    }
}

.cardButton {
    margin: auto !important;
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    &.modalButton {
        margin-top: 10px !important;
    }
    &.error-modal-button {
        i {
            margin-right: 5px;
        }
    }
}
.notCancelled {
    margin-top: 40px !important;
}

.dialog {
    .warning-message {
        margin-bottom: 10px;
        background-color: #f7fbcf;
    }
}

.el-dialog__body {
    text-align: center !important;
    .el-upload__tip {
        margin-bottom: 20px;
    }
    .icon {
        margin-top: 55px;
        .icon-minus {
            font-size: 27px;
        }
        .icon-plus {
            font-size: 27px;
        }
    }
    .spaceTop {
        margin-top: 40px;
    }
}

.waiting {
    text-align: center;
    width: 60%;
    margin: 40px auto;
    font-size: 15px;
}
.dialogButtons{
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 3rem;
}
.rangeSelector{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/partials/simulation/SimulationModal.vue